import { mutatorAction } from "satcheljs";
import getRewardsPointsStore from "../store/rewardsPointsStore";

export const setRewardsButtonVisibleInHeaderMutator: (accountKey: string, isVisible: boolean) => void = mutatorAction("SET_REWARDS_BUTTON_VISIBLE_IN_HEADER", (accountKey: string, isVisible: boolean): void => {
    const store = getRewardsPointsStore();
    store.buttonVisibilityAccountKey = accountKey;
    store.isButtonVisibleInHeader = isVisible;
});
